export default "__VITE_ASSET__Dy0F8PrI__"